module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_vm._l((_vm.couponGoodsList), function(item) {
    return _c('div', {
      staticClass: "goods-card"
    }, [_c('i', {
      staticClass: "el-icon-error activeDelBtn",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.removeCouponGoods(item)
        }
      }
    }), _vm._v(" "), _c('p', [_vm._v("\n      " + _vm._s(item.modelName) + " " + _vm._s(item.faultTypesName) + "\n      " + _vm._s(item.faultSubclassName) + "\n    ")]), _vm._v(" "), _c('h3', {
      staticClass: "sku"
    }, [_vm._v(_vm._s(item.skuNo))])])
  }), _vm._v(" "), _c('el-card', {
    staticClass: "add-btn",
    attrs: {
      "shadow": "never",
      "body-style": "padding: 0"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addHandler.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })]), _vm._v(" "), _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.goodsLoading),
      expression: "goodsLoading"
    }],
    attrs: {
      "title": "添加商品",
      "visible": _vm.dialogVisible,
      "width": "30%",
      "before-close": _vm.handleClose
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('input-tag', {
    attrs: {
      "width": "100%",
      "height": "200px",
      "placeholder": "请输入相关商品SKU，允许以逗号隔开"
    },
    on: {
      "saveTag": function (data) { return (_vm.goodsData = data); }
    }
  }), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addNewCouponGoods
    }
  }, [_vm._v("保存")])], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/template-compiler?{"id":"data-v-34d18055","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!/opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/biz/coupon/components/couponGoods.vue
// module id = 1636
// module chunks = 0